export enum PlateTypeEnum {
  COMMERCIAL_STONE = 'KOMERCIJALNI_KAMEN',
  TABLE = 'TABLA',
  READY_FORMATS = 'GOTOVI_FORMATI',
}
